<template>
  <accordion class="cheapest-deliveries" :max-height="500">
    <template #accordion>
      <span class="cheapest-deliveries__title">
        <template v-if="minPrice === 0">
          Бесплатная доставка
        </template>
        <template v-else>
          Доставка
          {{ minPriceFormatted }}
        </template>
      </span>
    </template>
    <div class="cheapest-deliveries__collapse-wrapper">
      <cheapest-deliveries-list :cheapest-deliveries="list" />
    </div>
  </accordion>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import useCheapestDeliveries from '@/compositions/useCheapestDeliveries';

import Accordion from '@/components/Accordion/index.vue';
import CheapestDeliveriesList from '@/components/CheapestDeliveriesList/index.vue';

export default defineComponent({
  name: 'CheapestDeliveries',
  components: {
    Accordion,
    CheapestDeliveriesList,
  },
  props: {
    cheapestDeliveries: { type: Array, default: () => ([]) },
  },
  setup(props) {
    const cheapestDeliveries = useCheapestDeliveries(props);
    return { ...cheapestDeliveries };
  },
});
</script>

<style lang="less">
.cheapest-deliveries {
  &__title {
    .p();

    width: 100%;
    text-align: left;
    padding: @size-x2 0 @size-x2 @size-x4;
  }
}
</style>
